import { Typography } from '@mui/material';
import {  observer } from 'mobx-react';
import React from 'react';
import { Processo } from '../../modelo';
import { DadosProcesso } from '../../modelo/dominio/DadosProcesso';

interface IPropsLabelTarefa {
    processo?: Processo;
    dadosProcesso?: DadosProcesso;
}

const TAREFA_PJE = 'Tarefa no Fluxo PJe: ';
const ULTIMO_ANDAMENTO = 'Último andamento: ';

class LabelTarefa extends React.Component<IPropsLabelTarefa> {


    render() {
        if (this.props.processo) {

            return (
                <b className="titulo">
                    {!this.props.processo.ehPje ? ULTIMO_ANDAMENTO : TAREFA_PJE}
                </b>
            );
        } else {
            return (
                <Typography component='b' variant='h6' className="titulo" >
                    {!this.props.dadosProcesso.origem.includes('P') ? ULTIMO_ANDAMENTO : TAREFA_PJE}
                </Typography>
            );

        }
    }
}

export default observer(LabelTarefa);
